
























import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bc-invoice-redraft-modal',
  components: {},
})
export default class InvoiceRedraftModal extends Vue {
  // PROPS
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop(Object) entity;

  // DATA
  loading = false;

  // COMPUTED

  // LIFECYCLE

  // METHODS
  closeModal() {
    this.$emit('close-modal');
    this.loading = false;
  }

  redrafted() {
    this.$emit('redrafted');
    this.loading = false;
  }

  async redraft() {
    this.loading = true;
    const basePath = this.$bpcApiRouteHelper.getEntityPath('invoices');
    this.$bpcApi.post(basePath + '/' + this.entity.id + '/redraft', {}).subscribe(
      res => {
        this.$bpcMessage.showSuccessMessage({ text: 'global.generic.successful_action' });
        this.redrafted();
      },
      error => {
        this.loading = false;
      },
    );
  }

  // WATCHERS
}
